import { Component, Inject, TemplateRef, ComponentFactoryResolver, ViewContainerRef } from '@angular/core';
import { UtilitiesService } from '../../services/shared/utilities.service';
import { CustomerService } from '../../services/customer/customer.service';
import { Customer } from '../../models/customer/customer-model';
import { Router } from '@angular/router';
import { EnumDropDown } from '../../models/shared/enum-dropdown';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { SiteMapsService } from '../../services/sitemap/site-maps.service';
import { SiteMapView } from '../../models/siteMaps/sitemap-model';
import { RolePermissionService } from '../../services/role/role-permission.service';
@Component({
    selector: 'app-site-maps',
    templateUrl: './site-maps.component.html',
    styleUrls: ['./site-maps.component.scss']
})
/** site-maps component*/
export class SiteMapsComponent {
  public siteMaps: SiteMapView[];
  public filteredItems: SiteMapView[];
  public productXML: string[];
  public blogXML: string[];
  public ImagesXML: string[];
  public isLoading: boolean;
  public publicXML: string[];
  public allSiteMapXML: string[];
  public isGenerateAllAllowed: boolean = false;
  public isGenerateOneAllowed: boolean = false;
    /** site-maps ctor */
  constructor(private readonly utilitiesService: UtilitiesService,
    public toastr: ToastsManager, public sitemapService: SiteMapsService, vcr: ViewContainerRef,
    private readonly rolePermissionService: RolePermissionService, private router: Router) {
    this.rolePermissionService.GetRolePermissions("sitemap").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });
          var list = data.filter(function (element) {
            return (element.action == "list");
          });

          var edit = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0)
            this.isGenerateAllAllowed = true;

          if (edit.length > 0)
            this.isGenerateOneAllowed = true;
          if (list.length > 0) {
            this.toastr.setRootViewContainerRef(vcr);
          this.getSitMapTypes();
            this.isLoading = false;
          }
          else {
            this.router.navigate(["/"]);
          }
        }
        else {
          this.router.navigate(["/"]);
        }
      }
    )
  }

  getSitMapTypes()
  {
    this.sitemapService.GetSitemapTypes().subscribe(
      data => {
        this.siteMaps = data;
        this.filteredItems = data;
        
      });
  }

  genrateSiteMap(id : Number){
    if (id == 0)
    {
      this.genrateAllSiteMap();
    }
    if(id == 1)
    {
      this.genrateBlogSiteMap();
    }
    else if (id == 2)
    {
      this.genrateProductSiteMap();
    }
    else if(id == 3)
    {
      this.genratePublicSiteMap();
    }
    else if(id == 4)
    {
      this.genrateImageSiteMap();
    }
  }

  genrateAllSiteMap() {
    this.isLoading = true;
    this.sitemapService.GenrateSitemaps().subscribe(
      data => {
        this.allSiteMapXML = data;
        this.toastr.success("Sitemap has been successfully genrated","Success");
        this.isLoading = false;
      });
  }

  genrateProductSiteMap()
  {
    this.isLoading = true;
    this.sitemapService.GenrateProductSiteMap().subscribe(
      data => {
        this.productXML = data;
        this.toastr.success("Sitemap has been successfully genrated","Success");
        this.isLoading = false;
      });
  }

  genrateImageSiteMap() 
  { 
    this.isLoading = true;
    this.sitemapService.GenrateImageSiteMap().subscribe(
      data => {
        this.ImagesXML = data;
        this.toastr.success("Sitemap has been successfully genrated","Success");
      this.isLoading = false;
      });
  }

  genratePublicSiteMap() {
    this.isLoading = true;
    this.sitemapService.GenratePublicSiteMap().subscribe(
      data => {
        this.publicXML = data;
        this.toastr.success("Sitemap has been successfully genrated","Success");
        this.isLoading = false;
      });
  }

  genrateBlogSiteMap() {
    this.isLoading = true;
    this.sitemapService.GenrateBlogsSiteMap().subscribe(
      data => {
        
        this.blogXML = data;
        this.toastr.success("Sitemap has been successfully genrated","Success");
        this.isLoading = false;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/sitemaps/site-maps/site-maps.component.ts